/* eslint-disable react/jsx-no-literals */
import React from 'react';
import styled from 'styled-components';

const GanttTitleHeader: React.FC = () => {
  return <TitleHeaderContainer>{/* Empty space - no title needed */}</TitleHeaderContainer>;
};

const TitleHeaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 10px;
`;

export { GanttTitleHeader };
